import ServiceGraphQL from 'src/service/gql-service';
import { leaveCompany } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const LeaveCompany = (id) => {
  const params = {
    query: leaveCompany.QUERY,
    variables: {
      id: id
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
